import { render, staticRenderFns } from "./SentReceivedContainer.vue?vue&type=template&id=3d0236a5&"
import script from "./SentReceivedContainer.vue?vue&type=script&lang=js&"
export * from "./SentReceivedContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports